import { ScreenerDimension } from '@revelio/data-access';

import { FilterId } from '../types/filters';

/** The screener dim a page's primary filter screens on; industry (and anything else) has no dim of its own. */
export const mapFilterIdToScreenerDimension = (
  filterId?: FilterId
): ScreenerDimension | undefined => {
  switch (filterId) {
    case FilterId.COMPANY:
      return ScreenerDimension.Company;
    case FilterId.GEOGRAPHY:
      return ScreenerDimension.Geography;
    case FilterId.ROLE:
      return ScreenerDimension.Role;
    default:
      return undefined;
  }
};
